import React, { useEffect, useRef, useState } from 'react';
import { isEmpty } from 'lodash';
import { Box, Card } from '@curves/ui-base';

import { useChartContext } from "@Local/Dashboard/Components/ChartContext";
import {
    LineChartBox, BarChartBox, PieChartBox, TotalBarChartBox
} from '@Local/Dashboard/Components';
import { chartTypeMap } from "@Local/Dashboard/staticData";
const ChartAdvancedContent = () => {
    const {
        chartType,
        sourceData,
        openSearch,
    } = useChartContext();
    const lineChartRef = useRef(null);
    const barChartRef = useRef(null);
    const pieChartRef = useRef(null);
    const [chartHeight, setChartHeight] = useState(0);
    useEffect(() => {
            if (!isEmpty(sourceData)) {
                if (barChartRef.current) barChartRef.current.setSource(sourceData);
                if (lineChartRef.current) lineChartRef.current.setSource(sourceData);
                if (pieChartRef.current) pieChartRef.current.setSource(sourceData);
            }
        },
        // eslint-disable-next-line
        [sourceData, chartType]
    );
    useEffect(() => {
            if (barChartRef.current) barChartRef.current.triggerResize('100%', `${chartHeight}px`);
            if (lineChartRef.current) lineChartRef.current.triggerResize('100%', `${chartHeight}px`);
            if (pieChartRef.current) pieChartRef.current.triggerResize('100%', `${chartHeight}px`);
        },
        // eslint-disable-next-line
        [openSearch]
    );
    useEffect(() => {
            const handleResize = () => {
                setChartHeight(window.innerHeight - 220);
            };
            handleResize();
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        },
        // eslint-disable-next-line
        []
    );
    return (
        <Box>
            <Card>
                <Card.CardContent className="dashboard-card p-4 px-2">
                    {isEmpty(sourceData) ? (
                        <Box className="text-center text-gray" style={{ height: `${chartHeight}px` }}>
                            請選擇資料搜尋條件
                        </Box>
                    ) : (
                        <React.Fragment>
                            {chartType === chartTypeMap.bar && (
                                <BarChartBox ref={barChartRef}
                                             xAxis={{
                                                 type: 'category',
                                                 axisLabel: { interval: 0, rotate: 30 }
                                             }}
                                             style={{ margin: '0', width: "100%", height: `${chartHeight}px` }} dark />
                            )}
                            {chartType === chartTypeMap.totalBar && (
                                <TotalBarChartBox ref={barChartRef}
                                             xAxis={{
                                                 type: 'category',
                                                 axisLabel: { interval: 0, rotate: 30 }
                                             }}
                                             style={{ margin: '0', width: "100%", height: `${chartHeight}px` }} dark
                                />
                            )}
                            {chartType === chartTypeMap.totalPercentBar && (
                                <TotalBarChartBox ref={barChartRef}
                                                  xAxis={{
                                                      type: 'category',
                                                      axisLabel: { interval: 0, rotate: 30 }
                                                  }}
                                                  style={{ margin: '0', width: "100%", height: `${chartHeight}px` }} dark
                                                  showPercent
                                />
                            )}
                            {chartType === chartTypeMap.line && (
                                <LineChartBox ref={lineChartRef}
                                              xAxis={{
                                                  type: 'category',
                                                  axisLabel: { interval: 0, rotate: 30 }
                                              }}
                                              style={{ margin: '0', width: "100%", height: `${chartHeight}px` }} dark />
                            )}
                            {chartType === chartTypeMap.pie && (
                                <PieChartBox ref={pieChartRef}
                                             style={{ margin: '0', width: "100%", height: `${chartHeight}px` }} dark />
                            )}
                        </React.Fragment>
                    )}
                </Card.CardContent>
            </Card>
        </Box>
    );
}
export default ChartAdvancedContent;